import { render, staticRenderFns } from "./AtencionTickets.vue?vue&type=template&id=5cc3716d"
import script from "./AtencionTickets.vue?vue&type=script&lang=js"
export * from "./AtencionTickets.vue?vue&type=script&lang=js"
import style0 from "./AtencionTickets.vue?vue&type=style&index=0&id=5cc3716d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports